module.exports = __webpack_public_path__ + "static/media/future-building.ba4a49fa.gif";